import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { FB_COLLECTION_PATH } from "./postActionTypes";

export interface WerkerChange {
  werkerUid: string;
  isInvited: boolean;
  existingDocId: string | null;
  werkerFirstName: string;
  werkerLastName: string;
  werkerProfilePicURL: string;
  werkerCompany?: string;
  werkerBio?: string;
  docCreatedAt?: number;
}

export interface JobContextInfo {
  company: string;
  location: string;
  locationCoordinates: string;
  pay: string;
  shiftIdentifier: string;
  shiftNotes: string;
  dateTimeStart: string;
  dateTimeFinish: string;
  numJobSlots: number;
  jobStatusSched: string;
}

export interface SchedulerProfileInfo {
  firstName: string;
  lastName: string;
  userId: string;
  profilePicURL: string;
}

/**
 * Trigger async werker invitation processing via cloud function.
 * Writes to pending collection which triggers cloud function to process invites in background.
 * Handles both single jobs and series (array of jobIds).
 * 
 * @param schedulerUID - The scheduler's user ID
 * @param jobIds - Array of job IDs (single element for single job, multiple for series)
 * @param werkerChanges - Array of werkers to add/remove with their current state
 * @param jobContextInfo - Job details (company, location, pay, etc.)
 * @param schedulerProfile - Scheduler profile info for creating job docs
 * @returns Promise with status
 */
export async function fx_FB_WerkerInvitePending(
  schedulerUID: string,
  jobIds: string[],
  werkerChanges: WerkerChange[],
  jobContextInfo: JobContextInfo,
  schedulerProfile: SchedulerProfileInfo,
  jobDatesMap?: Record<string, { dateTimeStart: string; dateTimeFinish: string }>
) {
  const userRef = collection(db, FB_COLLECTION_PATH.Users);
  
  await addDoc(collection(userRef, schedulerUID, "werkerInvitePending"), {
    InviteInfo: {
      schedulerUID,
      jobIds,
      werkerChanges,
      jobContextInfo,
      schedulerProfile,
      ...(jobDatesMap ? { jobDatesMap } : {}),
      timestamp: Date.now(),
    },
  });
  
  return { status: "pending" };
}
